import React from 'react'
import logo from "../assets/logo.png"
import { Instagram, Facebook, Linkedin, Youtube } from 'lucide-react';



export const Footer = () => {
  return (
    <>
    <div
      className="w-full bg-black px-[2rem] md:px-[5.5vw] text-white pt-[1rem] md:pt-[5rem] pb-[1rem] overflow-visible"
    >
      <div className="w-full flex flex-col md:flex-row gap-3 md:justify-between">
        <div className='md:w-[30vw] flex flex-col'>
       <img src={logo} alt="logo" className='w-24 h-24 -ml-5'/>
       <p className='text-[18px] mb-4'>Your entire photoshoot in seconds. No experience required, just a few clicks</p>
       <div className='flex items-center gap-2 mb-4'>  <a href="" className="li bg-white text-black p-1 rounded-lg" ><Facebook /></a>
       <a href="https://www.linkedin.com/company/gomens" className="li bg-white text-black p-1 rounded-lg"><Linkedin /></a>
       <a href="" className="li bg-white text-black p-1 rounded-lg"><Youtube /></a>
       <a href="" className="li bg-white text-black p-1 rounded-lg"><Instagram /></a></div>
     
       </div>
        
        <div className='flex itemcs-center md:flex-row flex-col gap-5 md:gap-32 justify-center'>
        <div className="followUs text-white flex flex-col leading-10">
          <h1 className="font-poppins font-semibold text-lg">Quick Links</h1>
          <a href="/">Home</a>
          <a href="/pricing">Pricing</a>
          <a href="/about">About Us</a>
          {/* <a href="#">Contact Us</a>           */}
        </div>
        <div className="followUs text-white flex flex-col leading-10">
            <h1 className="font-poppins font-semibold text-lg">Legal</h1>
            <a href="/policy-info">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/refund-policy">Refund Policy</a>
        </div>
        {/* <div className="product text-white leading-10">
          <h1 className="font-poppins font-semibold text-lg">AI Features</h1>
          <a ><h1>Virtual AI Model</h1></a>
          <a ><h1>Background Remover</h1></a>
          <a ><h1>Image Upscaler</h1></a>
          <a ><h1>Image Expander</h1></a>
          <a ><h1>AI Content Agent</h1></a>
        </div> */}
        </div>
      </div>
      <div className="w-full h-0.5 bg-gray-700"></div>
      <h1 className="text-md text-white mt-8 text-center">
        &copy; {new Date().getFullYear()} Gomens. All rights reserved.
      </h1>
    </div>
 

    </>
  )
}
